import VueRouter, { RouteConfig } from "vue-router";
import NotFoundView from "./views/NotFoundView.vue";
import { Container } from "inversify";
import { createAdminRoutes } from "./routes/admin";
import { createMemberRoutes } from "./routes/member";
import { scrollBehavior } from "../../common/src/utility/routerUtils";
import { SidebarStore } from "../../common/src/stores/SidebarStore";
import { createBaseGuestRoutes } from "./routes/guest/baseGuest";
import { createGSXGuestRoutes } from "./routes/guest/gsxGuest";
import { createThirdPartyAdminRoutes } from "./routes/thirdpartyAdmin";

export const createRouter = (container: Container): VueRouter => {
    const routes: RouteConfig[] = [
        ...getSubdomainRoutes(),
        ...createBaseGuestRoutes(),
        ...createAdminRoutes(container),
        ...createThirdPartyAdminRoutes(container),
        ...createMemberRoutes(container),
        { path: "*", component: NotFoundView },
    ];

    function getSubdomainRoutes(): RouteConfig[] {
        return createGSXGuestRoutes(container);
    }

    const router = new VueRouter({
        mode: "history",
        routes,
        linkActiveClass: "active",
        scrollBehavior,
    });

    router.afterEach(() => {
        const sidebarStore: SidebarStore = container.get(SidebarStore);
        sidebarStore.close();
    });

    return router;
};
